<script>
import CreateView from '../base/CreateView.vue'
import FormInput from '../form/form-input.vue'
import FormDatepicker from '../form/form-datepicker.vue'
export default {
  components: {
    CreateView,
    FormInput,
    FormDatepicker,
  },
  computed: {
    currentCompany () {
      return this.$store.getters['authentication/selectedCompany']
    }
  },
  methods: {
    resetted () {
      this.$store.dispatch('taxrate/create/updateItem', {company: this.$route.params['company']})
    }
  },
}
</script>
<template>
  <create-view store="taxrate" update-route="TaxRateUpdate" v-slot:default="slotProps" @reset="resetted">
    <form-input :store="slotProps.store" prop-name="name" class="col-4"></form-input>
    <form-input :store="slotProps.store" prop-name="taxRate" class="col-4"></form-input>
    <form-datepicker :store="slotProps.store" :translation-root="slotProps.translationRoot" prop-name="validFrom" format="YYYY-MM-DD" class="col-3"></form-datepicker>
    <form-datepicker :store="slotProps.store" :translation-root="slotProps.translationRoot" prop-name="validTo" format="YYYY-MM-DD" class="col-3"></form-datepicker>

  </create-view>
</template>

